import { BaseExerciseSchema, MetricType, zMetricType } from '@strength/domain';
import { WorkoutSetMetric } from '@strength/domain-workout';
import { z } from 'zod';

export const AddExerciseTabletSchema = BaseExerciseSchema.omit({
  exerciseBodyParts: true,
  exerciseEquipment: true,
  exerciseTags: true,
  videoUrl: true,
  imageUrl: true,
  trainingTypeId: true,
}).extend({
  team: z
    .object({
      id: z.uuid(),
      name: z.string(),
    })
    .nullish(),
});

export type SelectedExercise = z.infer<typeof AddExerciseTabletSchema>;

export type AddExerciseTablet = z.infer<typeof AddExerciseTabletSchema>;

const zSetMetricInputSchema = z.object({
  setIndex: z.number(),
  setId: z.string().optional(),
  workoutSetGroupId: z.string().optional(),
  value: z.string(),
  unit: z.string().optional(),
  error: z.string().optional(),
  forCollection: z.boolean().optional(),
});
export type SetMetricInput = z.infer<typeof zSetMetricInputSchema>;

export const zCreateEditExerciseMetricsSchema = z.object({
  metricId: z.uuid(),
  name: z.string(),
  sortOrder: z.number(),
  type: zMetricType,
  exerciseMetricId: z.string().optional(),
  inputsForSet: z.array(zSetMetricInputSchema),
});

export type CreateEditExerciseMetrics = z.infer<
  typeof zCreateEditExerciseMetricsSchema
>;

const zExerciseSectionEntry = z.object({
  workoutExerciseId: z.string(),
  exerciseSortOrder: z.number(),
  supersetSortOrder: z.number().optional(),
  exerciseName: z.string(),
  workoutSupersetId: z.string().optional(),
});

const zExerciseOrderSchema = z.object({
  workoutSectionId: z.string(),
  sectionName: z.string(),
  entries: z.array(zExerciseSectionEntry),
});

export type ExerciseSectionEntry = z.infer<typeof zExerciseSectionEntry>;

export type SupersetEntry = {
  workoutSupersetId: string;
  exerciseSortOrder: number;
};

export type ExerciseOrder = z.infer<typeof zExerciseOrderSchema>;

export const createEditExerciseTabletSchema = z.object({
  exercise: AddExerciseTabletSchema.nullable().refine((val) => val !== null, {
    message: 'exerciseSelectionRequired',
  }),
  isEachSide: z.boolean().default(false),
  metrics: z.array(zCreateEditExerciseMetricsSchema),
  exerciseOrder: z.array(zExerciseOrderSchema),
});

export type ExerciseFormData = z.infer<typeof createEditExerciseTabletSchema>;

export type MetricData = {
  metricId: string;
  sortOrder: number;
  metricType: MetricType;
  metricName: string;
  exerciseMetricId?: string;
};

export type SetData = {
  setId?: string;
  workoutSetGroupId?: string;
  sortOrder: number;
  metrics: WorkoutSetMetric[];
};

export type SetMetricData = {
  setId: string;
  metricId: string;
  input: string;
  forCollection: boolean;
};
